export default "__VITE_ASSET__D0bHEe7g__"